import $ from 'jquery';
import {getWidth} from "../utils/window";

export default function headerSection(context=document.body) {
	const $context = $(context);
	const $parents = $('#header-nav .-parent');

	$('[href="/#"]').click((e) => {
		e.preventDefault();
	});

	$parents.each(function () {
		const $this = $(this);
		const $a = $this.find('> a');

		$a.click((e) => {
			if (getWidth() < 1080) {
				e.preventDefault();
				const sub = $this.find('> ul');
				sub.slideToggle(500);
				$this.toggleClass('-active');
			}
		});
	})
}



// WEBPACK FOOTER //
// ./source/scripts/section/header.js